import { render, staticRenderFns } from "./AdvancedForm.vue?vue&type=template&id=4a960c3b&"
import script from "./AdvancedForm.vue?vue&type=script&lang=js&"
export * from "./AdvancedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports